import logoIcon from '@/assets/images/logo-comp.png';

type BrandLogoSize = 'nav' | 'home' | 'sidebar';

type BrandLogoProps = {
  size?: BrandLogoSize;
  className?: string;
};

const sizeClassMap: Record<BrandLogoSize, string> = {
  nav: 'brand-logo--nav',
  home: 'brand-logo--home',
  sidebar: 'brand-logo--sidebar',
};

export const BrandLogo = ({ size = 'nav', className = '' }: BrandLogoProps) => {
  const sizeClass = sizeClassMap[size];

  return (
    <span className={`brand-logo ${sizeClass} ${className}`.trim()}>
      <img
        src={logoIcon}
        alt=""
        className="brand-logo-icon"
        decoding="async"
      />
      <span className="brand-wordmark" aria-hidden="true">
        Hémo-J
      </span>
    </span>
  );
};
